export const REMINDER_DOWNLOAD_APP_EVENTS = {
    SELECT_REMINDER_DOWNLOAD_APP_COPY_LINK: 'select_copy_download_link',
    SELECT_REMINDER_DOWNLOAD_APP_QR: 'select_download_qr',
    SELECT_REMINDER_DOWNLOAD_APP_OPEN_POPUP: 'select_tell_your_teen_download'
} as const;